// http://mikemcl.github.io/big.js/

// æ¯å¦æ¯ä¸ä¸ªç±»ä¼¼æ°ç»å¯¹è±¡
export function isArrayLike(obj) {
    return type(obj) === 'string' || type(obj) === 'array';
}

export function isRegexp(reg) {
    return type(reg) === 'regexp'
}

export function isString(reg) {
    return type(reg) === 'string'
}

export function isNumber(reg) {
    return type(reg) === 'number'
}

// æ¯å¦ä¸ºæ´æ°
export function isInteger(value) {
    return isNumber(value) && isFinite(value) && Math.floor(value) === value;
}

export function isBoolean(reg) {
    return type(reg) === 'boolean'
}

export function isFunction(reg) {
    return type(reg) === 'function'
}

export function isArray(reg) {
    return Array.isArray(reg);
}

// è·åå­ç¬¦ä¸²å­èé¿åº¦ï¼1æ±å­=2å­è
export function getStrByteLength(str) {
    const length = str.length;
    let len = 0;
    for (let i = 0; i < length; i++) {
        if ((str.charCodeAt(i) & 0xff00) !== 0) {
            len++;
        }
        len++;
    }
    return len;
}

export function type(obj) {
    if (obj === null) {
        return 'null'
    }
    if (obj === undefined) {
        return 'undefined';
    }
    const _type = typeof obj;
    if (_type === 'object') {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    }
    return _type;
}

export function uuid(prefix = 'uuid') {
    return prefix + Math.random().toString(16).substr(2);
}

/**
 * å­èè½¬æ¢
 * @param bytes å­èå¤§å°
 */
export function bytesToSize(bytes) {
    if (bytes === 0) return '0 B';
    var k = 1024,
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(1) + ' ' + sizes[i];
}

/**
 * è½¬æ¢åèäºå¥ä¿çå°æ°
 * @param number
 * @param fractionDigits
 */
export function toFixed(number, fractionDigits) {
    var pow = Math.pow(10, fractionDigits || 0);
    number = Number(number) || 0;
    return Math.round(number * pow) / pow;
}

// å¤å¶å¯¹è±¡(ç®åç²æ´ï¼ï¼ï¼)
export function _copyObj(obj) {
    if (obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    return obj;
}

export function _find(list, key, value) {
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element[key] === value) {
            return element;
        }
    }
}

export function _findIndex(list, key, value) {
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element[key] === value) {
            return i;
        }
    }
}

export function _finds(list, key, ...values) {
    const result = [];
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        const el = _find(list, key, value);
        if (el) {
            result.push(el);
        }
    }
    return result;
}
